/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Sdchemie8Inputs */

const en__field_enum_sdchemie8 = /** @type {(inputs: _Field_Enum_Sdchemie8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 - Biochemie, Chemie und Pharmazie`)
};

const de__field_enum_sdchemie8 = /** @type {(inputs: _Field_Enum_Sdchemie8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`14 - Biochemie, Chemie und Pharmazie`)
};

/**
* | output |
* | --- |
* | "14 - Biochemie, Chemie und Pharmazie" |
*
* @param {_Field_Enum_Sdchemie8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_sdchemie8 = /** @type {((inputs?: _Field_Enum_Sdchemie8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Sdchemie8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_sdchemie8(inputs)
	return de__field_enum_sdchemie8(inputs)
});
export { _field_enum_sdchemie8 as "_field_enum_SDCHEMIE" }